import { CreatePartnerMaterialRequestSchema, CreatePartnerMaterialResponseSchema } from './create-partner-material.schema';
export const createPartnerMaterialContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-materials',
    description: 'Create a partner material',
    requestSchema: CreatePartnerMaterialRequestSchema,
    responseSchema: CreatePartnerMaterialResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only'
        }
    }
};

//# sourceMappingURL=create-partner-material.contract.js.map